import { CIAN_SOURCE_PARAM } from '../../constants/params';

export function getCianSource() {
  const url = new URL(window.location.href);
  const cianSource = url.searchParams.get(CIAN_SOURCE_PARAM);

  return cianSource;
}
